<template>
  <v-container grid-list-xl editBranchList>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-tabs slider-color="grey">
          <v-tab class="tab" :key="1" ripple>Details</v-tab>
          <v-tab class="tab" :key="2" ripple>Regions</v-tab>
          <v-tab class="tab" :key="3" ripple>Logo</v-tab>
          <v-tab class="tab" :key="4" ripple>Bank Details</v-tab>
          <v-tab class="tab" :key="5" ripple>T's & C's</v-tab>
          <v-tab class="tab" :key="6" ripple>Store Pricelists</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-container grid-list-xl>
                  <v-layout row wrap>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Name:</label>
                      <v-text-field label="Name" v-model="objBranchEdit.name" required :rules="nameRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Code:</label>
                      <v-text-field label="Branch Code" v-model="objBranchEdit.code" required :rules="codeRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Email:</label>
                      <v-text-field label="Email" v-model="objBranchEdit.email" required :rules="emailRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Description:</label>
                      <v-text-field label="Description" v-model="objBranchEdit.description" required :rules="descriptionRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Street Address 1:</label>
                      <v-text-field label="Street Address 1" v-model="objBranchEdit.address_one" required :rules="addressRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Street Address 2:</label>
                      <v-text-field label="Street Address 2" v-model="objBranchEdit.address_two" required :rules="addressRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Postal Code:</label>
                      <v-text-field label="Postal Code" v-model="objBranchEdit.postal_code" required :rules="addressRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Contact Number:</label>
                      <v-text-field label="Contact No" v-model="objBranchEdit.contact_no" required :rules="contactRules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex lg4>
                      <label class="blackLabel">* Store Override Main Details:</label>
                      <v-switch v-model="objBranchEdit.switch" single-line solo></v-switch>
                    </v-flex>
                    <v-flex lg4>
                      <div class="screenTip">
                          <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i>
                            Trade Rep is a rep linked to a specific customer for a specific store.  If one is not linked this rep will be used by default.
                          </span>
                        </div>
                      <label class="blackLabel">Trade Rep:</label>
                      <v-select :items="repsShortList" v-model="objBranchEdit.trade_rep" item-value="userid" item-text="full_name" label="Trade Rep" autocomplete solo></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-data-table :headers="regionHeader" v-if="userRegions != ''" :search="search" id="hello" :items="userRegions" class="elevation-1 mainTable" hide-actions disable-initial-sort :rows-per-page-items="[2000,40,60,80,100]">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td width="5%"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                      <td v-if="props.expanded == true" width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                      <td v-else width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props">
                    <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :search="search" :items="props.item.children" hide-actions class="elevation-1 subTable subTable1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                      <template slot="items" slot-scope="props">
                        <tr>
                          <td width="5%" class="levelone"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                          <td v-if="props.expanded == true" width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                          <td v-else width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                        </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :search="search" :items="props.item.children" hide-actions class="elevation-1 subTable2" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                          <template slot="items" slot-scope="props">
                            <tr>
                              <td width="5%" class="leveltwo"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                              <td v-if="props.expanded == true" width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                              <td v-else width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                            </tr>
                          </template>
                          <template slot="expand" slot-scope="props">
                            <v-data-table :headers="regionHeader" v-if="props.item.children != ''" :search="search" :items="props.item.children" hide-actions class="elevation-1 subTable3" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                              <template slot="items" slot-scope="props">
                                <tr>
                                  <td width="5%" class="levelthree"><v-switch @change="fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)" v-model="props.item.selected"></v-switch></td>
                                  <td v-if="props.expanded == true" width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_upward</i></td>
                                  <td v-else width="95%" class="cursor" @click="props.expanded = !props.expanded">{{ props.item.name }} <i v-if="props.item.children && props.item.children.length != 0" class="material-icons showHide">arrow_downward</i></td>
                                </tr>
                              </template>
                            </v-data-table>
                          </template>
                        </v-data-table>
                      </template>
                    </v-data-table>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg6>
                  <p>Please select a logo to upload ( Max size: 5mb )</p>
                  <input type="file" id="quoteFile" class="fileUpload" @change="fncSetImageObj">
                  <div class="fileHolder">
                    <p>Drag & Drop / Click to Add Files</p>
                    <small>{{ fileName }}</small>
                  </div>
                </v-flex>
                <v-flex lg6>
                  <p v-if="this.branchLogo == ''"><br /><strong>No logo has been uploaded</strong></p>
                  <p v-if="this.branchLogo != ''" style="margin-bottom: 5px;"><a @click.prevent="fncResetLogo" style="clear:both;cursor:pointer;">Remove Logo</a></p>
                  <img v-if="this.branchLogo != ''" :src="this.branchLogo" width="300" style="margin-top: 0px;" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-0 pb-4" :key="4">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <!--<v-flex lg12>
                  <label class="blackLabel">* Bank Details:</label>
                  <v-text-field label="Bank Details" v-model="objBranchEdit.bank_details" required :rules="bankRules" multi-line solo></v-text-field>
                </v-flex>-->
                <v-flex lg6>
                  <label class="blackLabel">* Bank Name:</label>
                  <v-text-field label="Bank Name" v-model="objBranchEdit.bank_name" required :rules="bankRules" solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Bank Branch Code:</label>
                  <v-text-field label="Bank Branch Code" v-model="objBranchEdit.bank_code" required :rules="bankRules" solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Account Number:</label>
                  <v-text-field label="Bank Account Number" v-model="objBranchEdit.bank_account" required :rules="bankRules" solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Account Type:</label>
                  <v-text-field label="Bank Account Type" v-model="objBranchEdit.bank_account_type" required :rules="bankRules" solo></v-text-field>
                </v-flex>
                <!--<v-flex lg12>
                  <label class="blackLabel">* Terms and Conditions:</label>
                  <v-text-field label="Terms and Conditions" v-model="objBranchEdit.terms_and_conditions" required :rules="termRules" multi-line solo></v-text-field>
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-0 pb-4" :key="5">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <label class="blackLabel">* Terms and Conditions:</label>
                  <v-text-field label="Terms and Conditions" v-model="objBranchEdit.terms_and_conditions" required :rules="termRules" multi-line solo></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-0 pb-4" :key="6">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <div class="screenTip">
                          <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i>
                            If a specific department is not mapped to a pricelist the calculator will use the pricelist mapped to 'All
                            departments'. If that is not set it will use the default pricelist.<br>
                            <b>Note: </b>Department to store pricing is only used if configured in the app. <br>
                        
                          </span>
                  </div>
                </v-flex>
                <v-btn @click="fncAddPricelist" color="success">Add Row</v-btn>              
                <v-data-table :headers="pricelistHeader" :items="storeDepartmentPricelist" hide-actions disable-initial-sort class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td width="35%"><v-select :items="departmentListFiltered" label="Department" item-value="id" item-text="name" v-model="props.item.departments" autocomplete solo></v-select></td>
                      <td width="35%"><v-select :items="pricelistList" label="Pricelist" item-value="pl_id" item-text="pl_name" v-model="props.item.pricelists" autocomplete solo></v-select></td>
                      <td width="20%"><v-switch v-model="props.item.is_default" single-line solo></v-switch></td>
                      <td width="10%"><a @click.prevent="fncDeleteRow(props.index)"><i class="material-icons">delete</i></a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right"> 
            <v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="addressSelected == false" :disabled="true" @click.stop="fncUpdateDepartment()">Update</v-btn>
            <v-btn color="success" class="text-xs-right" v-else :disabled="!isAddValid" @click.stop="fncUpdateDepartment()">Update</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Settings',
    data() {
      return {
        isAddValid: false,
        search: '',
        departmentName: '',
        departmentDescription: '',
        regionHeader: [
          { text: 'Select', value: '' },
          { text: 'Name', value: 'name' }
        ],
        pricelistHeader: [
          { text: 'Department', value: '' },
          { text: 'Pricelist', value: '' },
          { text: 'Default', value: '' },
          { text: 'Delete', value: '' }
        ],
        nameRules: [
          v => !!v || 'Store name is required',
        ],
        emailRules: [
          v => !!v || 'Store email is required',
        ],
        descriptionRules: [
          v => !!v || 'Store description is required',
        ],
        bankRules: [
          v => !!v || 'Store bank details are required',
        ],
        termRules: [
          v => !!v || 'Store terms and conditions are required',
        ],
        addressRules: [
          v => !!v || 'Store address is required',
        ],
        contactRules: [
          v => !!v || 'Store contact no is required',
        ],
        addressSelected: true,
        fileName: '',
        codeRules: [
          v => !!v || 'Store code is required',
        ],
        storeDepartmentPricelist: [{departments: [], pricelists: []}],
        departmentListFiltered: [{id: 'all', name: 'All Departments'}]
      };
    },
    methods: {
      fncDeleteRow( index ) {

        var newStoreDepartmentPricelist = [];
        for( var s in this.storeDepartmentPricelist ) {
          if( s != index ) {
            newStoreDepartmentPricelist.push( this.storeDepartmentPricelist[s] );
          }
        }
        this.storeDepartmentPricelist = newStoreDepartmentPricelist;

      },
      fncAddPricelist() {
        this.storeDepartmentPricelist.push({departments: '', pricelists: ''});
      },
      fncResetLogo() {
        this.$store.commit('setBranchLogo','');
      },
      fncSetImageObj(e) {
        var files = e.target.files[0] || e.dataTransfer.files[0];
        var fivemeg = 5 * 1000000;
        if (parseInt(files.size) > fivemeg) {
          var snackDetails = { color: 'error', message: 'Please upload a file smaller than 5MB', display: true };
          this.$store.commit('setSnack', snackDetails);
        } else {
          var vm = this;
          if (files.type == 'video/mp4' || files.type == 'application/pdf' || files.type === 'image/png' || files.type === 'image/jpg' || files.type === 'image/jpeg' || files.type == 'application/pdf' || files.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files.type == 'application/vnd.ms-excel' || files.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || files.type == 'application/msword' || files.type == 'application/x-zip-compressed' || files.type == 'text/plain') {
            this.fileObj = files;
            var currentInput = document.getElementById('quoteFile');
            currentInput.value = '';
            this.$store.dispatch({
              type: 'fncUploadBranchLogo',
              files: files
            })
          } else {
            var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
            this.$store.commit('setSnack', snackDetails);
          }
        }
      },
      fncHideModal() {
        this.$store.commit('hideModal');
      },
      fncCheckRegionSetup(regionId, regionStatus, regionParent) {
        this.addressSelected = true;
        this.$store.commit({
          type: 'fncCheckRegionSetup',
          regionId: regionId,
          regionStatus: regionStatus,
          parent: regionParent
        })
        if (regionStatus == false) {
          this.$store.commit('fncHideRegionParent', regionParent)
        }
      },
      fncUpdateDepartment() {

        var strStoreDepartmentPricelist = JSON.stringify( this.storeDepartmentPricelist );

        this.$store.dispatch({
          type: 'fncUpdateBranch',
          branchDetails: {
          branchRegions: this.userRegions,
          storeDepartmentPricelist: strStoreDepartmentPricelist
          }
        });
      },
      fncEditDeparment() {
        this.$store.dispatch('fncUpdateDepartment');
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'runAdd',
        'objBranchEdit',
        'userRegions',
        'branchLogo',
        'pricelistList',
        'departmentList',
        'repsShortList'
      ])
    },
    beforeMount(){
      this.$store.dispatch('fncPopulatePricelistList');
      this.$store.dispatch('fncPopulateDepartments');
      this.$store.dispatch('fncUserListShort');
    },
    watch: {
      departmentList() {
        for( var d in this.departmentList ) {
          this.departmentListFiltered.push({id: this.departmentList[d].id, name: this.departmentList[d].name})
        }
      }
    },
    mounted() {
      this.objBranchEdit.pricelist_id = String( this.objBranchEdit.pricelist_id );

      if( this.objBranchEdit.branch_department_pricelists == null || this.objBranchEdit.branch_department_pricelists == 'null' || this.objBranchEdit.branch_department_pricelists == '' ) {
        this.storeDepartmentPricelist = [{departments: '', pricelists: ''}];
      } else {
        this.storeDepartmentPricelist = JSON.parse( this.objBranchEdit.branch_department_pricelists );
      }

      for( var d in this.departmentList ) {
        this.departmentListFiltered.push({id: this.departmentList[d].id, name: this.departmentList[d].name})
      }

    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
